import { DispatchOf } from "../utils";
import { fetchContracts as contractsFetchContracts } from "../../services/hubspotContractService";
import * as types from "../../constants";
import { ContractsActions } from "../reducers/contractsReducer";
import { IContract } from "../../models/Contract";
import {ErrorsActions} from "../reducers/toastsReducer";

export function fetchContract(id: string, token: string) {
  return async (dispatch: DispatchOf<ContractsActions> & DispatchOf<ErrorsActions>) => {
    return contractsFetchContracts(id, token)
      .then((result: IContract | any) => {
        const allProducts = result.flatMap((i: any) => i.products)
        const contract = result.length > 0 ? result.pop() : {}
        if (contract) {
          contract.products = allProducts
        }

        dispatch({
          type: types.FETCH_CONTRACT,
          payload: contract,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function clearContract() {
  return ({
    type: types.CLEAR_CONTRACT
  })
}
